import { RootState } from '../../';

export const selectMixpanelState = (state: RootState) =>
  state.mixpanel?.status === 'Initialized' ? state.mixpanel : undefined;
export const selectMixpanelToken = (state: RootState) => selectMixpanelState(state)?.token;
